import cx from "classnames";
import { t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink";
import CS from "metabase/css/core/index.css";
import linkStyles from "metabase/css/core/link.module.css";
import { PLUGIN_ADMIN_SETTINGS } from "metabase/plugins";
import { useSelector } from "metabase/redux";
import { getUpgradeUrl } from "metabase/selectors/settings";
import { UnstyledButton } from "metabase/ui";

export function UpsellSdkLink() {
  const campaign = "embedding-sdk";
  const location = "embedding-sdk-admin";
  const upgradeUrl = useSelector((state) =>
    getUpgradeUrl(state, {
      utm_campaign: campaign,
      utm_content: location,
    }),
  );
  const { triggerUpsellFlow } = PLUGIN_ADMIN_SETTINGS.useUpsellFlow({
    campaign,
    location,
  });

  if (triggerUpsellFlow) {
    return (
      <UnstyledButton
        onClick={triggerUpsellFlow}
        c="core-brand"
        className={linkStyles.link}
        key="upgrade-button"
        fw="bold"
        fz="inherit"
      >
        {t`upgrade to MetrioniQ Pro`}
      </UnstyledButton>
    );
  }

  return (
    <ExternalLink
      key="upgrade-url"
      href={upgradeUrl}
      className={cx(CS.textBold, linkStyles.link)}
    >
      {t`upgrade to MetrioniQ Pro`}
    </ExternalLink>
  );
}
